import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { acceptAssetRentRequestAsAO, acceptAssetRentRequestAsMNO } from '@api/assetsRent';

import { IAcceptRequestParams } from '@interfaces/rent/dto/assetRentDTO';

import { ESnackbarTypes } from '@enums/common';

import { ASSET_RENT_REQUEST_CARD } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateAcceptAssetRentRequestCard = (id: string, onSuccessCallbacks: Array<() => void>) => {
	const dispatch = useAppDispatch();

	const { mutate: acceptAssetRentRequestCard } = useMutation<IAcceptRequestParams>({
		mutationKey: [ASSET_RENT_REQUEST_CARD, id],
		mutationFn: ({ id, isAO, comment }: IAcceptRequestParams) => {
			return isAO ? acceptAssetRentRequestAsAO(id, comment) : acceptAssetRentRequestAsMNO(id, comment);
		},
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetRentProposedDatesForItemSuccess,
				type: ESnackbarTypes.success,
			}));

			if (onSuccessCallbacks.length) {
				onSuccessCallbacks.forEach((callback) => callback());
			}
		},
	});

	return {
		acceptAssetRentRequestCard: (
			acceptAssetRentRequestCard as unknown as UseMutateFunction<any, any, IAcceptRequestParams, boolean>
		),
	};
};
